<template lang="html">
	<div :id="tagName">
	</div>
</template>
<script>
export default {
	props: {
		tagName: String
	},
	name: "TheMap"
}
</script>
<style lang="scss" scoped>
#the-map {
	width: 100%;
	height:100vh;
}
</style>